import { CreditReport } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

type BankruptcyDetailsProps = {
  bankrupcies?: CreditReport["bankruptcy_details"];
  isNoHit: boolean;
};

export const BankruptcyDetails = ({
  bankrupcies,
  isNoHit
}: BankruptcyDetailsProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Bankruptcy details">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Bankruptcy details">
      {bankrupcies?.length ? (
        <>
          {bankrupcies.map((bankruptcy, index) => (
            <div
              className="flex w-full gap-4"
              key={`credit-report-bankruptcy-${index}`}
            >
              <div className="w-full">
                <div className="h-7 w-full border-b border-alpha-40">
                  <p className="test-sm font-bold text-content-1000">
                    Bankruptcy Record {index + 1}
                  </p>
                </div>
                <div className="mt-4 flex w-full flex-wrap ">
                  <div className="flex w-full flex-col gap-3">
                    <Row title="Date Filed" value={bankruptcy.date_filed} />
                    <Row title="Type of Bankruptcy" value={bankruptcy.type} />
                    <Row
                      title="Date Reported"
                      value={bankruptcy.date_reported}
                    />
                    <Row title="Filer" value={bankruptcy.filer} />
                  </div>
                  <div className="flex w-full flex-col gap-3">
                    <Row
                      title="Intent"
                      value={
                        bankruptcy.current_intent_or_disposition_code
                          ?.description
                      }
                    />
                    <Row
                      title="PRI Intent/Disposition Code"
                      value={
                        bankruptcy.prior_intent_or_disposition_code?.description
                      }
                    />
                    <Row
                      title="Industry Codes"
                      value={bankruptcy.industry_code}
                    />
                    <Row
                      title="Current Disposition Dates"
                      value={bankruptcy.current_disposition_date}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="text-base font-medium">No data available</div>
      )}
    </Section>
  );
};
